module.exports = __webpack_public_path__ + "img/navbar.347a400c.webp";